import { LanguageCode } from "common/types/languageCode";
import { useSelector } from "common/utilities/react-redux";
import { getSiteLanguage } from "domains/language/selectors";

export const useWeforumUrl = () => buildWeforumUrl(useSelector(getSiteLanguage));

const buildWeforumUrl = (language: LanguageCode) => {
  const { host, protocol } = new URL(import.meta.env.VITE_WEFORUM_URL);
  const normalisedHost = host === "www.weforum.org" ? "weforum.org" : host;
  const newSubdomain = normalisedHost === "weforum.org";

  return language === LanguageCode.ES || language === LanguageCode.JA
    ? `${protocol}//${language === LanguageCode.JA ? "jp" : language}${newSubdomain ? "." : "-"}${normalisedHost}`
    : language === LanguageCode.ZH
      ? `${protocol}//${newSubdomain ? "cn." : "zh-"}${normalisedHost}`
      : import.meta.env.VITE_WEFORUM_URL;
};
